import React from 'react';
import { AdvancedImage } from '@cloudinary/react';
import { SiteStructureType } from '../../../../../../types/siteStructureType';
import { useResponsiveImage } from '../../../../hooks/useResponsiveImage';
import { BespokeHeader } from './BespokeHeader';
import { StandardHeader } from './StandardHeader';
import { BespokeHeaderProps, HeaderVariant } from './SectionPageHeader.types';

const HEADERS: Record<HeaderVariant, (props: BespokeHeaderProps) => React.ReactElement> = {
  [HeaderVariant.Standard]: StandardHeader,
  [HeaderVariant.Bespoke]: BespokeHeader,
};

type Props = Pick<SiteStructureType, 'name' | 'ingress' | 'image' | 'headerVariant' | 'runningHead'>;

export const SectionPageHeader = ({ name, ingress, image, headerVariant, runningHead }: Props) => {
  const mainImage = useResponsiveImage({
    imageId: image?.publicId || '',
    initialDimensions: { width: 400, height: 448 },
  });

  // Missing or unknown variants fall back to the standard header.
  const Header = (headerVariant && HEADERS[headerVariant]) || HEADERS[HeaderVariant.Standard];

  return (
    <Header
      title={name}
      ingress={ingress || undefined}
      runningHead={runningHead || undefined}
      imageOrVideo={
        mainImage && <AdvancedImage cldImg={mainImage} alt={image?.altText || ''} title={image?.caption || ''} />
      }
    />
  );
};
